import React, { useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const AddEducationAchievement = ({
  getUserCv,
  userDataId,
  handleCloseEducationAhievement,
  showEducationAchievement,
  educationData,
}) => {
  console.log("educationData", educationData);
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();
  const [achivement, setAchivement] = useState("");
  const [achivementDate, setAchivementDate] = useState("");
  const [display, setDisplay] = useState(false);

  // ...................................................................
  const [formChanged, setFormChanged] = useState(false); // Track if form is modified
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFieldChange = (setter, value, fieldName) => {
    setter(value);

    // Ensure values are strings (avoid errors with .trim())
    const updatedAchivement = fieldName === "achivement" ? String(value || "") : String(achivement || "");
    const updatedAchivementDate = fieldName === "achivementDate" ? String(value || "") : String(achivementDate || "");

    // Check if both required fields are filled
    const allFieldsFilled = updatedAchivement.trim() !== "" && updatedAchivementDate.trim() !== "";

    setFormChanged(allFieldsFilled);
  };
  // ......................................................................


  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    setIsSubmitting(true); // Disable the button during submission
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      eduId: educationData.usrDataEductnId,
      //   id: 0,
      achievement: achivement,
      achievementDate: moment(achivementDate).format("YYYY-MM-DD"),
    };
    console.log("body====>", body);
    if (achivement === "" || achivementDate === "") {
      toast.error("Please fill all the required fields");
      setIsSubmitting(false); // Re-enable the button if validation fails
    } else {
      try {
        const res = await axios.post("/Resume/AddEducationAchievement", body);
        toast.success(res.data.message);
        resetForm();
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      } finally {
        setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
      }
    }
  };

  const resetForm = () => {
    handleCloseEducationAhievement();
    getUserCv();
    setAchivement("");
    setAchivementDate("");
    setDisplay(false);
    setFormChanged(false); // Disable the button after update
  };

  const handleCloseEducationAhievementFn = () => {
    resetForm(); // Call resetForm when closing the modal
    handleCloseEducationAhievement();
  };

  return (
    <Modal
      show={showEducationAchievement}
      onHide={handleCloseEducationAhievementFn}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Add education achievement</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseEducationAhievementFn}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12} className="mb-2">
            <Form.Group controlId="grade">
              <Form.Label className="class-type">
                Achievement{" "}
                <span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={achivement}
                // onChange={(e) => setAchivement(e.target.value)}
                // onChange={(e) => handleFieldChange(setAchivement, e.target.value)} // Track changes
                onChange={(e) => handleFieldChange(setAchivement, e.target.value, "achivement")} // Ensure validation
                placeholder="Enter achievement"
                className="Dark-Input-from-group"
              />
              {display && !achivement ? (
                <span className="error_msg_lbl">Add achievement </span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
              <Form.Label className="class-type col-md-12">
                Achievement date{" "}
                <span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Flatpickr
                type="number"
                value={achivementDate}
                // onChange={(date) => setAchivementDate(date[0])}
                // onChange={(date) => handleFieldChange(setAchivementDate, date[0])}
                onChange={(date) => handleFieldChange(setAchivementDate, date[0], "achivementDate")} // Ensure validation
                placeholder="Enter achievement date"
                className="Dark-Input-from-group"
                // disabled={isPresent}
                options={{
                  maxDate: new Date(),
                  static: true, // Keeps the calendar visible on click         
                }}
              />
              {display && !achivementDate ? (
                <span className="error_msg_lbl">Select achievement date </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3"
              onClick={handleSubmit}
              style={{cursor: formChanged ? "pointer" : "default"}}
            >
              <a href="#/"
                // onClick={handleSubmit}
                className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                disabled={!formChanged || isSubmitting}
                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
              >
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddEducationAchievement;
